import { EDayOfWeek } from "../../../models"

export enum ETimeoffStatus {
	Requested = 0,
	Approved = 1,
	Denied = 2,
	Applied = 3
}

export interface IAppliedInfo {
	AppliedStartTime: Date | string
	AppliedEndTime: Date | string
}

export interface ITimeoffNote {
	Note: string
	DateTime: string
	UserId: string
	UserName: string
	StatusAssociatedWithNote: ETimeoffStatus
}

export interface ITimeoffRequestDocument {
	Id: string
	AccountId: string
	UserId: string
	UserDefaultHierarchyItemId: string
	UserDefaultJobId: string
	Description: string
	StartDate: string
	EndDate: string
	HoursPerDay: number
	TotalHours?: number
	Status: ETimeoffStatus
	AccrualId: string
	AccrualName: string
	Notes: ITimeoffNote[]
	Deleted?: boolean
	EmployeeName: string
	EmployeeExternalId: string
	TicksSinceChange?: number
	AppliedInPayroll?: boolean
	AppliedHours?: number
	AppliedInfo?: IAppliedInfo[]
	SupervisorIds?: string[]
	SpecifyDays: EDayOfWeek[]
	PayRate:number
}